<template>
  <FormKit
    :add-label="field.addLabel"
    :help-position="helpPosition"
    :help="field.instructions"
    :label="field.name"
    :name="name"
    :repeatable="true"
    :validation="validation"
    type="group"
  >
    <FormieRows :settings="settings" :rows="field.rows" />
  </FormKit>
</template>

<script setup lang="ts">
import { fieldHelpPosition, fieldName, fieldValidationArray, fieldVisible } from '~/assets/formie'

interface Props {
  settings: Record<string, unknown>
  field: Record<string, unknown> // todo: we should define parentField for consistency, but it should also be checked that this must always be undefined! (Formie does not support double nesting)
}

const props = defineProps<Props>()

const helpPosition = fieldHelpPosition(props.settings, props.field)
const name = fieldName(props.field)
const show = fieldVisible(props.field) // eslint-disable-line no-unused-vars, @typescript-eslint/no-unused-vars
const validation = [
  ...fieldValidationArray(props.field),
  props.field.minRows ? ['min', props.field.minRows, 'length'] : undefined,
  props.field.maxRows ? ['max', props.field.maxRows, 'length'] : undefined,
].filter((rule) => rule)
</script>
